
import React from "react";
import { Info, AlertTriangle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface UserData {
  first_name?: string;
  last_name?: string;
  company?: string;
  is_placeholder?: boolean;
}

interface UserDisplayNameProps {
  user: UserData;
}

const UserDisplayName: React.FC<UserDisplayNameProps> = ({ user }) => {
  if (user.is_placeholder) {
    return (
      <div className="flex items-center text-amber-600">
        <span>{`${user.first_name} ${user.last_name}`}</span>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <AlertTriangle className="h-4 w-4 ml-1 cursor-help" />
            </TooltipTrigger>
            <TooltipContent>
              <p>Placeholder data - actual profiles couldn't be accessed</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  }
  
  if (user.first_name === 'Unknown' && !user.last_name) {
    return (
      <div className="flex items-center text-amber-600">
        <span>Unknown</span>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="h-4 w-4 ml-1 cursor-help" />
            </TooltipTrigger>
            <TooltipContent>
              <p>User profile data not available</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  }

  return (
    <>
      {`${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Unknown'}
      {user.company && (
        <span className="block text-xs text-muted-foreground">
          {user.company}
        </span>
      )}
    </>
  );
};

export default UserDisplayName;
